import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SourceData } from '../../vform.models';

@Component({
  selector: 'vf-vsource-option',
  templateUrl: './vsource-option.component.html',
  styleUrls: ['./vsource-option.component.scss'],
})
export class VsourceOptionComponent {
  @Input()
  source: SourceData;
  @Input()
  initialChecked: boolean;
  @Input()
  disabled: boolean;

  @Output()
  sourceSelected = new EventEmitter<boolean>();
}
